import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ContentLoader from "react-content-loader";
import WeekDaySelect from "./utilities/WeekDaySelect";

const WEEK_DAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
];
const TableLoader = () => (
  <ContentLoader
    height={200}
    width={400}
    speed={2}
    primaryColor={"#f3f3f3"}
    secondaryColor={"#ecebeb"}
  >
    <rect
      x="101"
      y="16.05"
      rx="5"
      ry="5"
      width="220"
      height="16.299999999999997"
    />
    <rect x="101" y="50" rx="5" ry="5" width="220" height="10" />
    <rect x="101" y="74" rx="5" ry="5" width="220" height="10" />
    <rect x="100" y="100" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
);

class Week extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderDropDown = (day, weekDays) => {
    let weekday = weekDays.find(wd => {
      return wd.day === day;
    });

    return (
      <WeekDaySelect
        refetch={this.props.getDoctorWeekQuery.refetch}
        weekDay={weekday}
        options={this.props.allDayTemplatesQuery.allDayTemplates}
      />
    );
  };

  weekDays = weekDays => {
    return (
      <div>
        <div key={WEEK_DAYS[0]} className="week-day-select">
          <span>Lundi</span>
          {this.renderDropDown(WEEK_DAYS[0], weekDays)}
        </div>
        <div key={WEEK_DAYS[1]} className="week-day-select">
          <span>Mardi</span>
          {this.renderDropDown(WEEK_DAYS[1], weekDays)}
        </div>
        <div key={WEEK_DAYS[2]} className="week-day-select">
          <span>Mercredi</span>
          {this.renderDropDown(WEEK_DAYS[2], weekDays)}
        </div>
        <div key={WEEK_DAYS[3]} className="week-day-select">
          <span>Jeudi</span>
          {this.renderDropDown(WEEK_DAYS[3], weekDays)}
        </div>
        <div key={WEEK_DAYS[4]} className="week-day-select">
          <span>Vendredi</span>
          {this.renderDropDown(WEEK_DAYS[4], weekDays)}
        </div>
        <div key={WEEK_DAYS[5]} className="week-day-select">
          <span>Samedi</span>
          {this.renderDropDown(WEEK_DAYS[5], weekDays)}
        </div>
        <div key={WEEK_DAYS[6]} className="week-day-select">
          <span>Dimanche</span>
          {this.renderDropDown(WEEK_DAYS[6], weekDays)}
        </div>
      </div>
    );
  };

  render() {
    if (
      this.props.allDayTemplatesQuery.loading ||
      this.props.getDoctorWeekQuery.loading
    ) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <TableLoader />
          </div>
        </div>
      );
    } else {
      const weekDays = this.props.getDoctorWeekQuery.User.week.days;
      return this.weekDays(weekDays);
    }
  }
}
/*
  authenticateUser = async () => {
    const { email, password } = this.state;

    const response = await this.props.authenticateUserMutation({
      variables: { email, password }
    });
    localStorage.setItem(
      "graphcoolToken",
      response.data.authenticateUser.token
    );
    this.props.history.replace("/");
  };
}
*/
const ALL_DAYTEMPLATES_QUERY = gql`
  query AllDayTemplatesQuery($doctorId: ID!) {
    allDayTemplates(
      filter: { doctor: { id: $doctorId } }
      orderBy: createdAt_ASC
    ) {
      id
      name
    }
  }
`;
const GET_DOCTOR_WEEK_QUERY = gql`
  query GetDoctorWeekQuery($doctorId: ID!) {
    User(id: $doctorId) {
      id
      week {
        id
        days {
          dayTemplate {
            id
            name
          }
          id
          day
        }
      }
    }
  }
`;

export default compose(
  graphql(ALL_DAYTEMPLATES_QUERY, {
    name: "allDayTemplatesQuery",
    options: ({ doctorId }) => ({ variables: { doctorId } })
  }),
  graphql(GET_DOCTOR_WEEK_QUERY, {
    name: "getDoctorWeekQuery",
    options: ({ doctorId }) => ({
      variables: { doctorId },
      fetchPolicy: "network-only"
    })
  })
)(Week);



// WEBPACK FOOTER //
// ./src/components/Week.js